export default __webpack_public_path__ + "static/media/profile.08dcf19a.jpg";